export default "__VITE_ASSET__0aa1c0b0__"